/* */ 
'use strict';
var Schema = require('../schema');
module.exports = new Schema({include: [require('./json')]});
